import React, { useEffect } from 'react'
import { AppName } from '@/types/misc.def.ts'

type PageTitleProps = {
  value: string
}

export const PageTitle: React.FC<PageTitleProps> = ({ value }) => {
  useEffect(() => {
    document.title = `${value} | ${AppName}`

    return () => {
      document.title = `${AppName}`
    }
  }, [value])

  return <></>
}